module.exports = __webpack_public_path__ + "static/media/modern.68815ad5.png";